// extracted by mini-css-extract-plugin
export default {"errorBanner":"ErrorBanner_errorBanner__x8FVm"};